import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { RouteData } from '../../../app.routing.module';

@Injectable({
  providedIn: 'root'
})
export class KeycloakGuard implements CanActivate {

	constructor(private keycloakService: KeycloakService) {}

    public canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): boolean {
		const routeData = route.data as RouteData;
		const userRoles = this.keycloakService.getUserRoles();

		for (const roles of routeData.requiredRoles) {
			if (roles.every(role => userRoles.includes(role))) return true;
		}
		return false;
  	}
}
